'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var checkboxChecked = require('./checkbox-checked-d9b14409.js');
var Checkbox = _interopDefault(require('@material-ui/core/Checkbox'));

var StyledCheckbox = styled__default(Checkbox)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  &.secondary {\n    color: ", ";\n  }\n  &.checked.secondary {\n    color: ", ";\n  }\n"], ["\n  &.secondary {\n    color: ", ";\n  }\n  &.checked.secondary {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
var CheckboxField = function (_a) {
    var id = _a.id, checked = _a.checked, onChange = _a.onChange, value = _a.value, disableRipple = _a.disableRipple, _b = _a.iconViewBox, iconViewBox = _b === void 0 ? '0 0 24 24' : _b, disabled = _a.disabled, inputProps = _a.inputProps, restProps = tslib_es6.__rest(_a, ["id", "checked", "onChange", "value", "disableRipple", "iconViewBox", "disabled", "inputProps"]);
    return (React__default.createElement(StyledCheckbox, tslib_es6.__assign({ id: id, checked: checked, value: value, onChange: onChange, disableRipple: disableRipple, checkedIcon: React__default.createElement(checkboxChecked.CheckboxChecked, { viewBox: iconViewBox }), icon: (React__default.createElement(checkboxChecked.Checkbox, { viewBox: iconViewBox })), disabled: disabled, inputProps: inputProps, color: "secondary", classes: {
            checked: 'checked',
            colorSecondary: 'secondary',
        } }, restProps)));
};
var templateObject_1;

exports.CheckboxField = CheckboxField;
